import styled from 'styled-components';

import colors from '../../styles/colors';
import Button from '../Button/Button';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: fit-content;
  background-color: ${colors.base.gamma};
  border-radius: 5px;
  border: 1px solid ${colors.shades.gamma1};
`;

const ActionButton = styled(Button)`
  display: flex;
  justify-content: flex-start;
  outline: none;
  padding: 12px;
  background-color: transparent;
  font-size: 15px;
  width: 160px;
  border-bottom: 1px solid ${colors.shades.gamma1};
  cursor: pointer;

  &:hover {
    background-color: ${colors.shades.warning1};
    opacity: 1;
  }
  &:first-of-type {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  &:last-of-type {
    border-bottom: none;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
`;

export {
  Container,
  ActionButton,
};
